/* Guldsmedsmästaren — Booking page interactivity */
(function () {
  if (window.__gmBookingInit) return;
  window.__gmBookingInit = true;

  /* ─── Hero path toggle ───────────────────────── */
  const tabs = document.querySelectorAll('.gm-tabs button[data-tab]');
  if (!tabs.length) {
    initLightbox();
    return;
  }

  function showPath(path) {
    tabs.forEach((b) => {
      const active = b.dataset.tab === path;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    document.querySelectorAll('[data-copy]').forEach((el) => {
      el.hidden = el.dataset.copy !== path;
    });

    document.querySelectorAll('[data-tab-target]').forEach((el) => {
      el.hidden = el.dataset.tabTarget !== path;
    });

    document.querySelectorAll('[data-cta-for]').forEach((el) => {
      const label = el.dataset['label' + (path === 'christian' ? 'Christian' : 'Team')];
      if (label) el.textContent = label;
    });
  }

  tabs.forEach((b) => {
    b.addEventListener('click', () => showPath(b.dataset.tab));
  });

  initLightbox();

  /* ─── Gallery lightbox ───────────────────────── */
  function initLightbox() {
    const lightbox = document.querySelector('[data-lightbox]');
    if (!lightbox) return;
    const img = lightbox.querySelector('[data-lightbox-img]');
    const closeBtn = lightbox.querySelector('[data-lightbox-close]');

    function open(src, alt) {
      img.src = src;
      img.alt = alt || '';
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      img.src = '';
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-lightbox-src]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        open(trigger.dataset.lightboxSrc, trigger.dataset.lightboxAlt);
      });
    });

    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox || e.target === closeBtn) close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !lightbox.hidden) close();
    });
  }
})();
